import isDev from '@/functions/isDev.js';
const dev = isDev();

const b = dev
	? 'https://ac.dev.bhp.lifeon.cl/api'
	: 'https://ac.bhp.lifeon.cl/api';
/* 
disable_check_res : true //(por ahora sola para get/s) cuando se consulta, al recivir la info se comprueba si es el codigo de respuesta es uno usado para respuestas satifactorias, si no lo trae entonces cancela la cadena, si se especifica este atr como true se saltara esa validacion
message : '' // mostrara ese mensaje al costado derecho cuando se consulte
m : [strings] // lista de metodos a realizar por la consulta
b : '' // ruta base de la consulta
rp: '' // ruta relativa de la consulta
filter_by : [strings] //se definen ahi la lista de filtros que aceptara la consulta
name : [strings] // lista de copias de la consulta, la ruta relativa se incluye sola(no es necesario ingresarla en el []), se usa poder usar la consulta independientes como filtros externos(ejm: seria buscar un usuario sin que esto afecte al crud de usuarios)
st_key: '' // $store key
slot_key: '' // sincroniza las consultas gets por socket
*/
const endpoints = [];
const gs_po = ['GETS', 'POST'];
const g_pa = ['GET', 'PATCH'];
const g_po_pu_pa_d = ['GET', 'POST', 'PUT', 'PATCH', 'DELETE'];
const crud_m = ['GETS','GET', 'POST', 'PUT', 'PATCH', 'DELETE'];
const ae = (to_add) => endpoints.push(Object.assign({b},to_add));



/*
ae({b, m: gs_po, rp: 'enterprises/a/all', message: 'enterprises',st_key:'enterprises'});
ae({b, m: g_po_pu_pa_d, rp: 'enterprises/a', message: ''});
*/

/*
ae({b, m: gs_po, rp: 'req_all', message: '-------', st_key: '-------'});
ae({b, m: g_po_pu_pa_d, rp: 'req_single', message: '-------'});
 */


/* ae({b, m: ['GETSS'], rp: 'aggregate/critical_asset_by_organization', message: 'critical_asset_by_organization'}); */

ae({m: ['GET_EXPORT'], rp: 'export/tracking'});
ae({m: ['GET_EXPORT'], rp: 'export/critical_asset/simulation'});
ae({m: ['GET_EXPORT'], rp: 'export/spare_part/simulation'});
ae({m: ['GET_EXPORT'], rp: 'export/reported_actions'});
ae({m: ['GET_EXPORT'], rp: 'export/users', permission:17 });
ae({m: ['GET_EXPORT'], rp: 'export/prt_files_filter'});
ae({m: ['GET_EXPORT'], rp: 'export/action_tracker_issue'});
ae({m: ['GET_EXPORT'], rp: 'export/spare_part'});
ae({m: ['GET_EXPORT'], rp: 'export/critical_asset'});
ae({m: ['GET_EXPORT'], rp: 'export/reported_actions/temporary_engineering_measures_verifications'});
ae({m: ['GET_EXPORT'], rp: 'export/inspections'});
ae({m: ['GET_EXPORT'], rp: 'export/finding_map'});
ae({m: ['GET_EXPORT'], rp: 'export/spci'});
ae({m: ['GET_EXPORT'], rp: 'export/catastrophic_risk_analysis'});
ae({m: ['GETS'], rp: 'function/get_old_finding_sheet'});


ae({m: ['GETS'], rp: 'dashboard/status/all', message: 'dashboard_status_all'});
ae({m: ['GETS'], rp: 'aims_policy/1', message: 'aims_policy_1'});
ae({m: ['GETS'], rp: 'aims_policy/a/all', message: 'aims_policy', st_key:'aims_policy'});
ae({m: ['PATCH_M'], rp: 'aims_policy/a'});
ae({m: ['GETS','GET'], rp: 'dashboard/status/prt_info', message: 'dashboard_status_prt_info'});
ae({m: ['GETS'], rp: 'dashboard/status/prt_per_specialities', message: 'dashboard status prt_per_specialities'});

ae({
	m: ['GETS'], rp: 'join/critical_asset/detail/functional_location/a/all', message: 'critical_asset',
	filter_by:['f__with_ea '],
	name:['by_prt_ac']
});
ae({m: ['POST_M'], rp: 'spare_part_image/a/all', message: 'spare_part_image'});
ae({m: ['DELETE'], rp: 'spare_part_image/a', message: 'spare_part_image'});
ae({m: ['POST_M'], rp: 'critical_asset_images/a/all', message: 'critical_asset_images'});
ae({m: ['DELETE'], rp: 'critical_asset_images/a', message: 'critical_asset_images'});
ae({rp:'track_activitie/a/all', m: ['GETS'], message: 'track_activitie', name:[],filter_by:['s__action','d__creation_date__gte']});

ae({
	m: ['GETS'], rp: 'online_monitoring/critical_asset/a/all', message: 'critical_asset',
	/* filter_by:['f__with_ea '],
	name:['by_prt_ac'] */
});
ae({m: ['GET'], rp: 'online_monitoring_components', message: 'online_monitoring_components'});
ae({m: ['POST'], rp: 'online_monitoring_component/a/all'});
ae({m: ['PATCH', 'DELETE'], rp: 'online_monitoring_component/a'});
ae({m: ['GET'], rp: 'helper/get_all_remediation_status', message: 'get_all_remediation_status'});

ae({m: gs_po, rp: 'asset_class/a/all', message: 'asset_class', st_key:'asset_class'});
ae({m: g_po_pu_pa_d, rp: 'asset_class/a'});
ae({m: ['GETS'], rp: 'notification/a/all', message: 'notifications', slot_key: null,filter_by:[], name:['news']});
ae({m: ['PATCH'], rp: 'notification/a', message: 'notifications'});



ae({m: ['GETSS'], rp: 'aggregate/critical_asset_by_organization', message: 'critical_asset_by_organization'});
ae({m: ['GETSS'], rp: 'dashboard/principal/spare_part/by_organization/ri', message: 'spare_part by_organization ri'});
ae({m: ['GETSS'], rp: 'dashboard/principal/spare_part/by_organization/csp', message: 'spare_part by_organization csp'});

ae({m: ['PUT'], rp: 'function/recover/critical_asset'});
ae({m: ['PUT'], rp: 'function/recover/spare_part'});
ae({m: ['PUT'], rp: 'function/historical_disabled_review/critical_asset', refresh_my_management_pending: true});
ae({m: ['PUT'], rp: 'function/historical_disabled_review/spare_part', refresh_my_management_pending: true});

ae({m: ['POST_M'], rp: 'action_photographic_records'});
ae({m: ['DELETE'], rp: 'action_photographic_record'});
ae({m: ['GET','PATCH'], rp: 'reported_action', message: 'reported_action', reset_rq_rp:['dashboard/count_findings']});
ae({m: ['POST','GETS'], rp: 'reported_actions'/* , st_key:'reported_actions' */});
const reported_actions_filter_by = [
	's__critical_asset__functional_locations__functional_location',
	's__critical_asset__name',
	's__critical_asset__organization__name',
	'as__finding_code',
	'as__notebook_code',
	'f__responsible_area',
	'ae__priority',
	'ae__status',
	's__finding_code',
	'f__my_findings',
	'f__official_fiscal_year',
	'created__gte',
	'created__lte',
	'ae__remediationactions__state',
	's__remediationactions__sap_notice_number',
	's__remediationactions__sap_ot_number',
	'ae__critical_asset__name',
	'ae__name',
	'aes__critical_asset__name',
	'aes__name',
	'f__expired_remediation_date',
	'f__remediation_with_extension',
	'critical_asset__bowtie',
	'f__summarized_finding_state',
	'f__has_temporary_engineering_measures',
	'f__temporary_engineering_measures_status',
	'speciality'
];
const reported_actions_names = [
	'official',
	'historical',
	'pending',
	'finished',
	'doughnut',
	'finding_code',
	'notebook_code',
	'my_findings',
	'simulations',
	'removed_findings',
	'count_findings_01',
	'count_findings_02',
	'count_findings_03',
	'count_findings_04',
	'count_findings_05',
	'count_findings_06',
	'count_findings_07',
	'count_findings_08',
	'count_findings_09',
	'count_findings_10',
	'count_findings_11',
	'count_findings_12',
	'count_findings_13'
];
ae({m: ['POST','GETS'], rp: 'reported_actions/a/all', st_key:'findings',message: 'hallazgos',
	filter_by: reported_actions_filter_by,
	name:reported_actions_names,
});
ae({m: ['GETS'], rp:'dashboard/count_findings', st_key:'count_findings',message: 'hallazgos',
	filter_by: reported_actions_filter_by,
	name:reported_actions_names
});

ae({m: ['POST','GETS'], rp: 'reported_action/simulate/a/all',message: 'hallazgos', filter_by: reported_actions_filter_by,name:['simulations','doughnut','finding_code'] });

ae({m: ['GET'], rp: 'dashboard/findings/priority/count'});

ae({m: ['GET'], rp: 'version_control/compare/critical_asset'});
ae({m: ['GET'], rp: 'version_control/compare/spare_part'});
ae({m: ['GET'], rp: 'finding_summary'});

ae({m: ['GET'], rp: 'edit_action/reported_action'});
ae({m: ['GET'], rp: 'edit_action/remediation'});
ae({m: ['GET'], rp: 'edit_action/following_remediation'});
ae({m: ['GET'], rp: 'edit_action/closing_remediation'});
ae({m: ['GET'], rp: 'edit_action/closing_action'});
ae({m: ['GET'], rp: 'action_workflows'});

ae({m: ['GETS', 'POST','GETSS'], rp: 'user/a/all', message: 'user',
	filter_by:['s__username','s__employee_id','s__employee_name','is_active','f__name_similarity'],
	name:['in','in-table'],
});
ae({m: ['GET', 'POST', 'PUT', 'PATCH', 'DELETE','PATCH_RESTORE'], rp: 'user/a', message: ''});

ae({m: ['GETSS'], rp: 'users', message: ''})

ae({m: ['GETSS'], rp:'user_with_roles/a/all', once:true});
ae({m: gs_po, rp: 'role/a/all', message: 'role'});
ae({rp:'dashboard/user_profile_summary', m: ['GETS']});
//ae({b:'http://localhost:3000', m: ['POST'], rp: 'update_notification'});

ae({rp:'dashboard/action_tracker_issue/barplot', m: ['GET']});
ae({rp:'dashboard/action_tracker_issue/donut', m: ['GET']});
ae({rp:'dashboard/kri/individual_table', m: ['GETSS']});
ae({rp:'data/action_tracker/types', m: ['GETSS'], once:true});

ae({m: ['POST','GETS'], rp: 'action_tracker_issues/a/all',message: 'action_tracker_issues',
	filter_by:['s__responsible_user__employee_name','original_due_date__gte','original_due_date__lte','ae__status','f__state','as__type','complete_percent__gte'],
	name:['doughnut','bar'],
});

ae({m: ['POST','GETS'], rp: 'prt_files_filter/a/all',message: 'prt_files_filter',
	filter_by:['critical_asset_id__organization','aid__speciality','file_type','code','s__critical_asset_id__name','ae__speciality','f__due_date_status','critical_asset_id__organization'],
	name:['by_prt_specialities','by_prt_total','bar'],
});
ae({m: ['GET','PATCH'], rp:'spare_part/a'});
ae({m: ['POST','GETS'], rp:'spare_part/a/all', message: 'spare_part',
	filter_by:[
		'f__due_date_status',
		'bowtie',
		'as__critical_asset__name',
		'organization',
		'as__name',
		's__mfl_event',
		'ae__spare_part_type',
		'impacted_areas',
		'as__materialnumber__number',
		's__critical_asset__functional_locations__functional_location',
		'as__critical_asset__functional_locations__functional_location',
		'f__max_severity',
		'f__official_fiscal_year',
		'f__official_date__gte',
		'f__official_date__lte',
		'ae__state',
		'ae__critical_asset',
		'aes__name',
		'ae__critical_asset__name',
		'discharge_lock',
	],
	name:[
		'max_severity',
		'simulations',
		'official',
		'historical',
		'pending',
		'historical_disabled',
		'check_status',
		'spare_parts_filter',
		'material_number_filter',
		'filter_by_functional_location',
		'dashboard_management_count',
		'dashboard_management_bar',
		'discharge_asset',
	],
});
ae({m: ['PATCH','GET'], rp:'critical_asset/a'});
const ca_filter_by = [
	'f__has_spare_part',
	'f__due_date_status',
	'bowtie',
	's__name',
	'organization',
	'impacted_areas',
	's__mfl_event',
	's__functional_locations__functional_location',
	'standard',
	's__tag',
	'asset_class',
	'f__max_severity',
	'f__official_fiscal_year',
	'f__official_date__gte',
	'f__official_date__lte',
	'ae__state',
	'ae__name',
	'aes__name',
	'discharge_lock',
	'f__name_similarity',
]
const ca_name = [
	'max_severity',
	'simulations',
	'official',
	'historical',
	'pending',
	'historical_disabled',
	'check_status',
	'filter_by_functional_location',
	'dashboard_management_count',
	'dashboard_management_bar',
	'filter_by_name',
	'filter_by_tag',
];
ae({m: ['POST','GETS','GETSS'], rp:'critical_asset/a/all', message: 'critical_asset',
	filter_by:ca_filter_by,
	name:ca_name,
});

ae({m: ['POST','POST','GETS','GETSS'], rp:'catastrophic_risk_analysis/official/a/all', message: 'catastrophic_risk_analysis',
	filter_by:ca_filter_by,
	name:ca_name,
});
ae({m: ['GET','DELETE'], rp:'catastrophic_risk_analysis/official/a'});

ae({m: ['GETSS'], rp:'bowties'});
ae({m: ['GET','PATCH'], rp:'bowtie/a'});
ae({m: ['POST','GETS','GETSS'], rp:'bowtie/a/all',filter_by:[], name:[],message: 'bowtie' });

ae({m: ['GET'], rp:'workflow_files'});
ae({m: ['POST'], rp:'simulations/to_asi_request/spare_part'});
ae({m: ['POST'], rp:'simulations/to_asi_request/critical_asset'});
ae({m: ['PUT_NO_ID'], rp:'forward_workflow', refresh_my_management_pending: true});
ae({m: ['POST_M'], rp:'generic_files'});

ae({m: ['GET'], rp: 'my_management/pending_summary'});
ae({m: ['GET'], rp: 'my_management/action_tracker_issues'});
ae({m: ['GETS'], rp:'my_management/critical_spare_parts/a/all', message: 'critical_spare_parts',filter_by:[]});
ae({m: ['GETS'], rp:'my_management/important_spare_parts/a/all', message: 'critical_spare_parts',filter_by:[]});
ae({m: ['GETS'], rp:'my_management/critical_assets/a/all', message: 'critical_assets',filter_by:[]});


/* las consultas para datos de graficos son GET */
ae({m: ['GET'], rp:'dashboard/management/critical_asset/a/all'});
ae({m: ['GET'], rp:'dashboard/management/spare_part/a/all'});

ae({m: ['GET'], rp:'dashboard/management/critical_asset/cumulative/a/all'});
ae({m: ['GET'], rp:'dashboard/management/spare_part/cumulative/a/all'});
ae({m: ['GETSS'], rp:'workflows'});

ae({b, m: ['GETS'], rp: 'helper/get_all_remediation_status_mapping', message: 'remediation_status',st_key:'remediation_status_mapping'});

ae({m: ['GET','PATCH_M'], rp:'dashboard/backlog_report'});

ae({m: ['GET','PATCH_M','DELETE'], rp:'dashboard/backlog_report_list/a'});
ae({m: ['GETS','POST_M'], rp: 'dashboard/backlog_report_list/a/all', message: 'dashboard_backlog_report_list', st_key:'dashboard_backlog_report_list'});

ae({m: ['GETS','POST_M','GETSS'], rp:'spare_part_documents/a/all', message: 'spare_part_documents',filter_by:['f__belongs_to','f__type']});
ae({m: ['GET','PATCH_M','DELETE'], rp:'spare_part_documents/a'});
ae({m: ['GETS','POST_M','GETSS'], rp:'critical_asset_documents/a/all', message: 'critical_asset_documents',filter_by:['f__belongs_to','f__type']});
ae({m: ['GET','PATCH_M','DELETE'], rp:'critical_asset_documents/a'});
ae({m: ['PATCH'], rp:'remove_finding'});

ae({m: ['GET','PATCH_M','DELETE'], rp:'discharge_finding_files/a'});
ae({m: ['GETS','POST_M','GETSS'], rp:'discharge_finding_files/a/all', message: 'discharge_finding_files',filter_by:['finding']});

ae({m: ['GETS','POST_M','GETSS'], rp:'custom/impact_percentage_files/a/all', message: 'impact_percentage_files',filter_by:['asset','tipo']});

ae({m: ['GETSS'], rp:'workflow_files', message: 'workflow_files',filter_by:['spare_part','critical_asset']});

ae({m: ['GETS','POST_M','GETSS'], rp:'max_remediation_date_extension_justification/a/all', message: 'max_remediation_date_extension_justification', filter_by:['remediation']});
ae({m: ['GET','PATCH_M','DELETE'], rp:'max_remediation_date_extension_justification/a'});

ae({m: ['GETSS'], rp:'sgs_online_monitoring/get_overview'});

ae({m: ['GETS'], rp:'dashboard/backlog_report_list/a/no_paginated/all'});
ae({m: ['GET'], rp:'join/critical_asset/detail/fl'});
ae({m: ['GET','PATCH'], rp:'simulations/critical_asset'});
ae({m: ['GET'], rp:'critical_asset_prt_files'});
ae({m: ['GETSS'], rp:'custom/impact_percentage_files'});
ae({m: ['POST'], rp:'simulations/critical_assets',filter_by:[], name:[],message: 'simulations/critical_assets' });
ae({m: ['POST'], rp:'critical_assets',filter_by:[], name:[],message: 'critical_assets' });
ae({m: ['PUT'], rp:'critical_asset'});
ae({m: ['GETS','POST_M','GETSS'], rp:'catastrophic_risk_analysis_files/a/all', message: 'catastrophic_risk_analysis_files', filter_by:['f__belongs_to','f__type']});
ae({m: ['GET','PATCH_M','DELETE'], rp:'catastrophic_risk_analysis_files/a'});

ae({m: ['GETS','POST_M','GETSS'], rp:'online_monitoring_reports/a/all', message: 'online_monitoring_reports',
	filter_by:['report_datetime__gte','report_datetime__lte','f__year','f__week']
});
ae({m: ['GET','PATCH_M'], rp:'online_monitoring_reports/a'});
ae({m: ['PATCH'], rp:'add_finding_inspection_date/a'});
ae({m: ['GET'], rp:'get_finding_inspection/a'});

ae({m: ['PATCH'], rp:'remove_finding_inspection_date/a'});
ae({m: ['PATCH'], rp:'edit_finding_inspection_date/a'});

ae({m: ['POST'], rp: 'temporary_engineering_measures/nested/create'});
ae({m: ['PATCH'], rp:'temporary_engineering_measures/nested/edit'});
ae({m: ['DELETE'], rp:'temporary_engineering_measures/nested/delete'});

ae({m: ['PATCH'], rp: 'critical_asset/swap_discharge_lock/a'});
ae({m: ['PATCH'], rp: 'spare_part/swap_discharge_lock/a'});
ae({m: ['GETSS'], rp:'dashboard/opened_findings_per_area'});
ae({m: ['GETS','POST_M','GETSS'], rp:'temporary_engineering_measure_files/a/all', message: 'temporary_engineering_measure_files', filter_by:['remediation']});
ae({m: ['GET','PATCH_M','DELETE'], rp:'temporary_engineering_measure_files/a'});

ae({m: ['POST'], rp: 'temporary_engineering_measures_verifications/create'});
ae({m: [/* 'DELETE' */'PATCH'], rp:'temporary_engineering_measures_verifications/delete'});

ae({m: ['GETS','POST_M','GETSS'], rp:'temv_files/a/all', message: 'temv_files', filter_by:[],name:[]});
ae({m: ['GET','PATCH_M','DELETE'], rp:'temv_files/a'});

ae({m: ['PATCH'], rp:'remediation_action', reset_rq_rp:['dashboard/count_findings'], refresh_my_management_pending: true});
ae({m: ['PATCH'], rp:'closing_action', reset_rq_rp:['dashboard/count_findings'], refresh_my_management_pending: true});
ae({m: ['PATCH'], rp:'closing_remediation_action', reset_rq_rp:['dashboard/count_findings'], refresh_my_management_pending: true});
ae({m: ['PATCH'], rp:'following_remediation_action', reset_rq_rp:['dashboard/count_findings'], refresh_my_management_pending: true});

const spci_filter_by = [
	'aes__bcei__name',
	'bcei__organization',
	's__bcei__tag',
	's__description',
	's__functional_location',
	's__maintenance_plan_id',
	's__maintenance_item_id',
];
const spci_name = ['official'];
ae({m: ['GETS','GETSS'], altp:'fire_protection_systems/list/all',  rp:'fire_protection_systems/a/all', message: 'fire_protection_systems',
	filter_by:spci_filter_by,
	name:spci_name,
});
ae({m: ['POST'], rp:'fire_protection_systems/a', altp:'fire_protection_systems/create'});
ae({m: ['GET'], rp:'fire_protection_systems/a',altp:'fire_protection_systems/detail'});
ae({m: ['PATCH'], rp:'fire_protection_systems/a',altp:'fire_protection_systems/edit'});
ae({m: ['PATCH'], rp:'remove_spci',altp:'fire_protection_systems/remove'});

ae({m: ['GET','PATCH_M','DELETE'], rp:'discharge_spci_files/a',altp:'removed_fps_justification_files'});
ae({m: ['GETS','POST_M','GETSS'], rp:'discharge_spci_files/a/all',altp:'removed_fps_justification_files/all', message: 'discharge_spci_files',filter_by:['fire_protection_system']});


ae({m: ['GETS','GETSS'], rp:'fire_protection_systems_bcei/a/all', altp:'fire_protection_systems/bcei/list/all', message: 'critical_asset',
	filter_by:ca_filter_by,
	/* name:ca_name, */
});

ae({m: ['GETS','GETSS'], rp:'remediation_plannings/areas/a/all', message: 'remediation_plannings/areas', filter_by:[],name:[]});


ae({m: ['PATCH','DELETE'], rp:'fps_components/a',altp:'fps_components'});
ae({m: ['GETS','POST'], rp:'fps_components/a/all',altp:'fps_components/all', message: 'fps_components',filter_by:['fire_protection_system']});

export default endpoints;
